{
	"id": 7503,
	"moduleNumber": 3,
	"title": "The Professional Educator and the Student",
	"subtitle": "Practice ethical decisions around student welfare, boundaries, and educator-student trust.",
	"kgNodeId": "module-3",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 3 focuses on educator-student ethical tensions through two scenarios: Mr. Arnold's interactions with students and Coach Buckner's response to a student-athlete situation. Learners practice recognizing boundary concerns, balancing student welfare with role obligations, and choosing MCEE-aligned actions.",
	"estimatedDurationMinutes": 45,
	"activityCount": 3,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
